import { put, takeLatest } from 'redux-saga/effects';
import { SIGN_IN, SIGN_IN_FAIL, SIGN_IN_SUCCESS } from '../redux/authReducer';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js'
import history from '../store/history';
import userpool from '../helpers/userpool';
import { FETCH_USER_DATA } from '../redux/UserData';

const authenticate = (Email, Password) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: Email,
      Pool: userpool,
    })

    const authDetails = new AuthenticationDetails({
      Username: Email,
      Password,
    })

    user.authenticateUser(authDetails, {
      onSuccess: (result) => {
        resolve(result)
      },
      onFailure: (err) => {
        reject(err)
      },
    });
  });
};


function* signInFlow({ payload, }) {
  try {
    yield authenticate(payload.email, payload.password)
    yield put(SIGN_IN_SUCCESS());
    localStorage.setItem('dealer_email', payload.email)
    history.push('/dashboard/browse');
    yield put(FETCH_USER_DATA())
  } catch (error) {
    yield put(SIGN_IN_FAIL(error));
  }
}

export default function* SignIn() {
  yield takeLatest(SIGN_IN, signInFlow);
}
